import { useTheme } from '@emotion/react'

import { useFeatureFlag } from '@cash-web/shared-data-access-feature-flags'
import { unicodeToEmojiSvg } from '@cash-web/shared-feature-emojis'
import { replaceWithCDNImageUrl } from '@cash-web/shared-util-url'

type PaychecksDistributionHeroProps = {
  hero: { color?: string; value: string; label: string }
  avatar_url?: string
  iconUnicode?: string
}

const PaycheckDistributionHeroImage = ({ imageHref }: { imageHref?: string }) => {
  return <image href={imageHref} width="12" height="12" x="44.5%" y="24.5%" mask="url(#circle)" />
}

export const PaychecksDistributionHero = ({ avatar_url, iconUnicode, hero }: PaychecksDistributionHeroProps) => {
  const { colors, darkMode } = useTheme()
  const useNewEmojis = useFeatureFlag('cash-web-account-savings-use-updated-goal-images')

  return (
    <>
      {avatar_url ? (
        <>
          <defs>
            <mask id="circle">
              <circle cx="50%" cy="30%" r="6" fill="white" />
            </mask>
          </defs>
          <circle cx="50%" cy="30%" r="6" fill={colors.formFieldBackground} />
          <PaycheckDistributionHeroImage imageHref={replaceWithCDNImageUrl({ url: avatar_url })} />
        </>
      ) : iconUnicode ? (
        <PaycheckDistributionHeroImage
          imageHref={unicodeToEmojiSvg({
            unicode: iconUnicode,
            size: 24,
            darkMode,
            version: useNewEmojis ? 'new' : 'old',
          })}
        />
      ) : null}
      <text
        x="50%"
        y="47%"
        textAnchor="middle"
        dominantBaseline="middle"
        fontWeight="700"
        fill={hero.color ?? colors.label}
      >
        {hero.value}
      </text>
      <text
        x="50%"
        y="59%"
        textAnchor="middle"
        dominantBaseline="middle"
        fontWeight="500"
        fontSize={7}
        fill={colors.label}
      >
        {hero.label}
      </text>
    </>
  )
}

export const HeroVariant = ({ avatar_url, iconUnicode, hero }: PaychecksDistributionHeroProps) => {
  const { colors, darkMode } = useTheme()
  const useNewEmojis = useFeatureFlag('cash-web-account-savings-use-updated-goal-images')

  return (
    <>
      {avatar_url ? (
        <>
          <defs>
            <mask id="circle">
              <circle cx="50%" cy="30%" r="6" fill="white" />
            </mask>
          </defs>
          <circle cx="50%" cy="30%" r="6" fill={colors.formFieldBackground} />
          <PaycheckDistributionHeroImage imageHref={replaceWithCDNImageUrl({ url: avatar_url })} />
        </>
      ) : iconUnicode ? (
        <PaycheckDistributionHeroImage
          imageHref={unicodeToEmojiSvg({
            unicode: iconUnicode,
            size: 24,
            darkMode,
            version: useNewEmojis ? 'new' : 'old',
          })}
        />
      ) : null}
      <text x="50%" y="47%" textAnchor="middle" dominantBaseline="middle" fontWeight="700" fill={colors.label}>
        {hero.value}
      </text>
      <text x="50%" y="57.5%" textAnchor="middle" dominantBaseline="middle" fontSize={5} fill={colors.textSubtle}>
        {hero.label}
      </text>
    </>
  )
}
